import {FrontendRequest} from "services-comun/modules/net/request-frontend";
import {logRejection} from "services-comun/modules/decorators/metodo";
import dominio from "../../portal/ed";
import {stringify} from "qs";
import {QueryFiltro} from "./query";
import {INoticiaPortadilla} from "./interface";

export class NoticiasWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);

    @logRejection(true)
    public static async portadilla(query: QueryFiltro, p1: number, pn: number, pagina: number): Promise<number[]> {
        const params = stringify({
            ...query.toPlain(),
            p1,
            pn,
            pagina,
        });

        return this.get<number[]>(`${this.SERVICIO}/web/noticias/portadilla/?${params}`).then(resp => resp.data).catch(() => [] as number[]);
    }

    @logRejection(true)
    public static async resumen(id: number): Promise<INoticiaPortadilla> {
        const params = stringify({
            id,
        });
        return this.get<INoticiaPortadilla>(`${this.SERVICIO}/web/noticias/resumen/?${params}`).then(resp => resp.data);
    }

}
